import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const TableSkeletonTalkingPoint = () => (
  <Box className={styles['table-skeleton__container']}>
    <Table className={styles['table__skeleton']}>
      <Thead>
        <Tr>
          <Th className={styles['skeleton__head']} minWidth="200px">
            <SkeletonComponent height="18px" width="60%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="200px">
            <SkeletonComponent height="18px" width="55%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="402px">
            <SkeletonComponent height="18px" width="30%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="120px">
            <SkeletonComponent height="18px" width="70%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="100px">
            <SkeletonComponent height="18px" width="50%" />
          </Th>
          <Th className={styles['skeleton__head']} minWidth="120px">
            <Flex justifyContent="center">
              <SkeletonComponent height="18px" width="50%" />
            </Flex>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Iteration
          items={[1, 2, 3, 4, 5]}
          render={(num) => (
            <Tr key={num}>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="18px" width="80%" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="18px" width="70%" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="18px" width="75%" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="24px" width="70%" borderRadius="4px" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <SkeletonComponent height="24px" width="70%" borderRadius="4px" />
              </Td>
              <Td className={styles['skeleton__column']} verticalAlign="top">
                <Flex justifyContent="center" gap="10px">
                  <SkeletonComponent height="32px" width="32px" borderRadius="4px" />
                  <SkeletonComponent height="32px" width="32px" borderRadius="4px" />
                </Flex>
              </Td>
            </Tr>
          )}
        />
      </Tbody>
    </Table>
  </Box>
);

export default TableSkeletonTalkingPoint;
